"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var omit_1 = __importDefault(require("lodash/omit"));
var react_1 = __importDefault(require("react"));
var TableRow_1 = __importDefault(require("atomicComponents/atoms/Table/TableRow"));
var Cell_1 = __importDefault(require("atomicComponents/molecules/Table/Cell"));
var EntryRow = function (_a) {
    var entry = _a.entry;
    var _b = __read(react_1.default.useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(TableRow_1.default, __assign({ onClick: function () { return setIsOpen(!isOpen); } }, { children: [(0, jsx_runtime_1.jsx)(Cell_1.default, { children: entry.GROUP }), (0, jsx_runtime_1.jsxs)(Cell_1.default, { children: ["Id: ", entry.Id] }), (0, jsx_runtime_1.jsxs)(Cell_1.default, { children: ["QB Company Name: ", entry.docId.split('_')[1]] }), (0, jsx_runtime_1.jsx)(Cell_1.default, { children: (0, jsx_runtime_1.jsx)("button", __assign({ type: "button", onClick: function () { return null; } }, { children: isOpen ? 'Close' : 'Open' })) })] })), isOpen && ((0, jsx_runtime_1.jsx)(TableRow_1.default, { children: (0, jsx_runtime_1.jsx)(Box_1.default, { children: (0, jsx_runtime_1.jsx)("pre", { children: JSON.stringify((0, omit_1.default)(entry, ['GROUP', 'docId']), null, 2) }) }) }))] }));
};
exports.default = EntryRow;
